import { render } from "./ProgramStatisticsCards.vue?vue&type=template&id=44b146fa&scoped=true"
import script from "./ProgramStatisticsCards.vue?vue&type=script&lang=js"
export * from "./ProgramStatisticsCards.vue?vue&type=script&lang=js"

import "./ProgramStatisticsCards.vue?vue&type=style&index=0&id=44b146fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44b146fa"

export default script